import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        btnId: Number,
    }
    connect() {
        const button = document.getElementById(this.btnIdValue);

        button.addEventListener('click', ()=>{
            this.element.play();
            const s = button.style;
            s.opacity = 1;
            (function fade(){(s.opacity-=.1)<0?s.display="none":setTimeout(fade,40)})();
        });


    }
}
